
  

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { getDietMainData } from './AiDietapi';
import { LoginContext } from '../../MainLayout/MainLayout';
import CarouselSlider from '../../Shared/CarouselSlider/CarouselSlider';
import IntroSection from '../../Shared/IntroSection/IntroSection';
import SecondSection from '../../Shared/SecondSection/SecondSection';
import CurebaySolutions from '../../Shared/CurebaySolutions/CurebaySolutions';
import ThirdSection from '../../Shared/ThirdSection/ThirdSection';
import CheckHealthSteps from '../../Shared/CheckHealthSteps/CheckHealthSteps';
import ConcernsSection from '../../Shared/ConcernsSection/ConcernsSection';
import LoginToast from '../../MainLayout/ToastifyLogin';
import axios from 'axios';
import { usePatientData } from "../../hooks/usePatientData";
import { FeedbackModal, useServicePageFeedback } from '../Home/FeedbackSystem';

const AiDiet = () => {
  const { openLogin } = useContext(LoginContext);
  const storedData1 = JSON.parse(localStorage.getItem("loginObj"));
  const userData = storedData1;
  const { showFeedback, closeFeedback } = useServicePageFeedback(userData?.code, 'Smart Diet');

  const [attrs, setAttrs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pre-loading patient info
  const [patientInfo, setPatientInfo] = useState(null);
  const [slogans, setSlogans] = useState([]);
  const [loadingPatientInfo, setLoadingPatientInfo] = useState(false);
  const [expandedCard, setExpandedCard] = useState(null);

  const toastRef = useRef(null);
  const loginToastRef = useRef(null);
  const navigate = useNavigate();
  const { patientData } = usePatientData();
  const [report_count, setReportCount] = useState(null);
    const endpointBase = process.env.REACT_APP_REPORTCOUNTURL;
    const countApiUrl = `${endpointBase}smartdiet/reports/count`;

  // Pre-load patient info when page loads
  useEffect(() => {
    let isMounted = true;

    const fetchPatientInfo = async () => {
      const patientCode = userData?.code || sessionStorage.getItem("patientCode");

      console.log('patientCode:', patientCode);
      console.log('BASE URL:', process.env.REACT_APP_SMARTDIET_BASEURL);

      if (patientCode && !patientInfo) {
        setLoadingPatientInfo(true);
        console.log('🔄 Pre-loading patient info for:', patientCode);

        try {
          const response = await axios.get(
            `${process.env.REACT_APP_SMARTDIET_BASEURL}user/patientinfo?patient_id=${patientCode}`
          );

          if (isMounted && response.data) {
            const patientData = Array.isArray(response.data)
              ? response.data[0]
              : response.data.data?.[0];

            if (patientData) {
              setPatientInfo(patientData);
              console.log('✅ Patient info pre-loaded:', patientData);
            }

            if (response.data.slogans && Array.isArray(response.data.slogans)) {
              setSlogans(response.data.slogans);
            }
          }
        } catch (err) {
          console.error('❌ Error pre-loading patient info:', err);
        } finally {
          if (isMounted) {
            setLoadingPatientInfo(false);
          }
        }
      }
    };

    fetchPatientInfo();
    return () => { isMounted = false; };
  }, [userData?.code]);
  useEffect(() => {
      if (!countApiUrl) return;
    
      const fetchCount = async () => {
        try {
          const res = await fetch(countApiUrl);
          const data = await res.json();
          setReportCount(data.report_count ?? null);
        } catch (err) {
          console.error("Failed to fetch report count:", err);
        }
      };
    
      fetchCount();
    }, [countApiUrl]);
  const handleSecondButton = () => {
  navigate("/my-smart-diets");
};

  const handleCardClick = (item) => {
  const subheading = item?.subheading?.toLowerCase() || "";

  // VisionCare is live — open its page
  if (subheading === "visioncare") {
    navigate("/visioncare");
    return;
  }

  if (subheading === "caresathi") {
    navigate("/caresathi");
  } else if (subheading === "skincare") {
    navigate("/skincare");
  } else if (subheading === "smartvitals") {
    navigate("/smartvital");
  } else if (subheading === "oralcare") {
    navigate("/oralcare");
  } else if (subheading === "lungscare") {
    navigate("/lungscare");
  } else if (subheading === "smart report") {
    navigate("/smartreport");
  } else if (subheading === "symptomchecker") {
    navigate("/symptomchecker");
  } else if (subheading === "smart diet") {
    navigate("/smartdiet");
  } else {
    console.warn("No route found for:", subheading);
  }
};

  const handleOpen = (e) => {
    if (!userData?.code) {
      e.preventDefault();
      openLogin();
      return;
    }
    sessionStorage.setItem("patientCode", userData.code);
    console.log('🚀 Navigating with pre-loaded data:', { patientInfo, slogans });

    // ✅ React Router v6 syntax
    navigate("/smartdiet/generate", {
      state: {
        patientInfo: patientInfo,
        slogans: slogans,
        sourcechannel: patientData?.sourcechannel, 
        createdby: patientData?.createdBy,           
      }
    });
  };

  // Fetch CMS data
  useEffect(() => {
    let isMounted = true;
    getDietMainData()
      .then(res => {
        if (!isMounted) return;
        const entry = res.data?.data?.[0]?.attributes;
        setAttrs(entry || {});
      })
      .catch(err => {
        if (!isMounted) return;
        setError(err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => { isMounted = false; };
  }, []);

  if (loading) return <div className="p-8 text-center">Loading…</div>;
  if (error) return <div className="p-8 text-center text-red-600">Error loading data.</div>;
  if (!attrs) return <div className="p-8 text-center">No data</div>;

  const firstcompItem = attrs.first?.[0] || {};
  const firstSectionItems = [
    {
      heading: firstcompItem.heading || '',
      subheading: firstcompItem.subheading || '',
      description: firstcompItem.description || '',
      button: firstcompItem.button || '',
      button1: firstcompItem.button1 || '',
      onButtonClick: handleOpen,
      onSecondButtonClick: handleSecondButton,

      image: firstcompItem.imgurl || '',
    },
  ];

  const secondcompArr = attrs.second?.map(item => item.secsub) || [];
  const thirdSection = attrs.third?.[0] || {};
  const fourthSection = attrs.fourth?.[0] || {};
  const fifthSection = attrs.fifth?.[0] || {};
  const sixthSection = attrs.sixth?.[0] || {};
  const seventhSection = attrs.seventh?.[0] || {};
  const seventhSectionItems = seventhSection?.seventhsub || [];

  return (
    <>
      <LoginToast ref={loginToastRef} />
      <Toast ref={toastRef} position="top-right" />

      <section>
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-secondaryColor/8 to-transparent rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute bottom-32 right-16 w-96 h-96 bg-gradient-to-tr from-lightBlue/10 to-transparent rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: '1s' }}
          ></div>
          <div
            className="absolute top-1/2 left-1/4 w-48 h-48 bg-gradient-to-br from-secondaryColor/6 to-transparent rounded-full blur-2xl animate-bounce"
            style={{ animationDelay: '2s', animationDuration: '3s' }}
          ></div>
        </div>

        {/* SECTION 1: HERO */}
        <IntroSection items={firstSectionItems} 
        report_count={report_count}/>

        {/* SECTION 2 */}
        {secondcompArr.length > 0 && (
          <SecondSection items={secondcompArr} />
        )}

        {/* SECTION 3 */}
        {Object.keys(thirdSection).length > 0 && (
          <ThirdSection data={thirdSection} />
        )}

        {/* SECTION 4 */}
        {Object.keys(fourthSection).length > 0 && (
          <CheckHealthSteps data={fourthSection} onButtonClick={handleOpen} />
        )}

        {/* SECTION 5 */}
        {Object.keys(fifthSection).length > 0 && (
          <ConcernsSection data={fifthSection} />
        )}

        {/* SECTION 6 */}
        {Object.keys(sixthSection).length > 0 && (
          <CurebaySolutions data={sixthSection} onCardClick={handleCardClick} />
        )}

        {/* SECTION 7: CAROUSEL SLIDER */}
        {seventhSectionItems.length > 0 && (
          <section className="seventh-section w-full bg-White py-16">
            <div className="max-w-7xl mx-auto px-4">
              {/* Section Header */}
              <div className="text-center mb-12">
                <div className="inline-block mb-4">
                  <div className="inline-flex items-center gap-2 bg-lightBlue shadow-sm rounded-full px-6 py-2 mb-3">
                    {seventhSection.iconurl && (
                      <img src={seventhSection.iconurl} alt="icon" className="w-5 h-5 object-contain" />
                    )}
                    <span className="text-sm font-medium text-quantumPrimary">
                      {seventhSection.icondesc}
                    </span>
                  </div>
                </div>

                <h2
                  className="text-3xl md:text-4xl font-bold mb-4 w-fit mx-auto"
                  style={{
                    background: 'linear-gradient(to right, #00BD7F, #00CFA5, #00B5E2)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  {seventhSection.heading}
                </h2>
              </div>

              {/* Carousel */}
              <CarouselSlider
                items={seventhSectionItems}
                visibleSlides={3}
                renderItem={(item) => (
                  <div
                    key={item.id}
                    className="bg-White rounded-lg shadow-lg hover:shadow-xl transition-shadow flex flex-col max-w-sm mx-auto"
                  >
                    {item.imgurl && (
                      <div className="relative h-56 overflow-hidden">
                        <img
                          src={item.imgurl}
                          alt={item.subheading}
                          className="w-full h-full object-cover"
                        />
                        {item.iconurl && (
                          <div className="absolute bottom-4 left-7 w-16 h-16 rounded-full flex items-center justify-center shadow-md">
                            <img
                              src={item.iconurl}
                              alt="icon"
                              className="w-16 h-16 object-contain"
                            />
                          </div>
                        )}
                      </div>
                    )}

                    <div className="p-6 bg-lightBlue flex flex-col flex-grow">
                      <h3 className="text-xl font-semibold text-quantumPrimary mb-3">
                        {item.subheading}
                      </h3>
                      <p className="text-textGray text-sm mb-4">
                        {item.description}
                      </p>

                      {expandedCard === item.id && item.points && (
                        <ul className="space-y-3 mb-6">
                          {item.points.map((point) => (
                            <li key={point.id} className="flex items-start gap-3">
                              <span className="inline-block w-1.5 h-1.5 rounded-full bg-lightBlue2 mt-2 flex-shrink-0"></span>
                              <span className="text-sm text-textGray">
                                {point.points}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}

                      <button
                        onClick={() =>
                          setExpandedCard(expandedCard === item.id ? null : item.id)
                        }
                        className="inline-flex items-center gap-2 text-quantumPrimary font-semibold text-sm hover:text-secondaryColor transition-colors w-fit mt-auto"
                      >
                        {expandedCard === item.id ? "Read less" : "Read more"}
                        <ChevronRight size={16} className="text-[#00BFA5]" />
                      </button>
                    </div>
                  </div>
                )}
              />
            </div>
          </section>
        )}
      </section>
      {showFeedback && (
        <FeedbackModal service="Smart Diet" patientId={userData?.code} onClose={closeFeedback} />
      )}
    </>
  );
};

export default AiDiet;